<section
  class="px-4 py-14 bg-ayr-white dark:bg-ayr-black text-ayr-black dark:text-ayr-white"
>
  <div class="max-w-960 m-auto">
    <h2
      class="max-w-[620px] text-[36px] lg:text-[45px] leading-[44px] text-center inline m-auto font-bold text-bold"
    >
      <span class="block">
        <span
          class="flex gap-2 justify-center flex-col items-center lg:flex-row"
        >
          <img
            class="ayr-image inline-block w-24 lg:w-20"
            width="100px"
            height="40px"
            src="https://storage.googleapis.com/weayr-assets-non-prod/svg/ayr-logo.svg"
            alt="Ayr logo"
          />
          <span
            class="align-bottom leading-none lg:align-middle lg:leading-normal"
          >
            {{ "citizens.prints.title.one" | translate }}</span
          >
          <span
            class="ayr-underline dark:text-shadow inline-block text-bold max-lg:mt-[-0.5rem]"
          >
            {{ "citizens.prints.title.two-inline" | translate }}
          </span>
        </span>

        <span
          class="ayr-underline dark:text-shadow inline-block text-bold max-md:w-min"
          >{{ "citizens.prints.title.three-inline" | translate }}</span
        >
        <span
          class="ayr-underline dark:text-shadow inline-block text-bold pl-2"
          >{{ "citizens.prints.title.fourth-inline" | translate }}</span
        >
      </span>
    </h2>
    <p class="max-w-[620px] text-[16px] m-auto mt-11 text-center">
      {{ "citizens.prints.description.first" | translate
      }}<b>{{ "citizens.prints.description.first-bold" | translate }}</b>
    </p>
    <p class="max-w-[620px] text-[16px] m-auto mt-8 text-center">
      {{ "citizens.prints.description.second" | translate }}
      <b>{{ "citizens.prints.description.second-bold" | translate }}</b>
      {{ "citizens.prints.description.second-last" | translate }}
    </p>

    @if (list) {
      <div class="block mt-14">
        <app-image-slider [images]="list"></app-image-slider>
      </div>
    }
  </div>
</section>
